module.exports = __webpack_public_path__ + "static/media/pointer.92788e3e.svg";